(function () {
    'use strict';
    var m = angular.module('configuration');
    m.factory('anomalyExceptionsParams', ["modals", "$q", "anomalyExceptionsDao", function (modals, $q, anomalyExceptionsDao) {
        function strCapitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        var excludeType = function (type) {
            return {
                id: type,
                paramsLabel: strCapitalize(type),
                addTitle: 'Add ' + strCapitalize(type) + ' to exceptions list'
            };
        };
        var anomalyExceptionsParams = {
            addDialog: function (type, addParams) {
                var typeInfo = excludeType(type);
                if (!typeInfo) {
                    return $q.reject();
                }
                var modalParams = [
                    {
                        id: 'ids',
                        type: 'list',
                        label: typeInfo.paramsLabel,
                        validation: { required: true },
                        data: addParams && addParams.data
                    },
                    {
                        id: 'comment',
                        type: 'text',
                        label: 'Comment (optional)',
                        paramClass: 'text-param-average'
                    },
                    {
                        id: 'event_metadata',
                        hidden: true,
                        data: addParams.event_metadata
                    },
                    {
                        id: 'event_id',
                        hidden: true,
                        data: addParams.sec_event_id
                    },
                    {
                        id: 'apply_backward',
                        type: 'boolean',
                        rightLabel: 'Apply Backward',
                        emptyLabel: true
                    }
                ];
                if (addParams && addParams.message) {
                    modalParams.unshift({
                        type: 'message',
                        message: addParams.message,
                        paramClass: 'full-width-param'
                    });
                }
                return modals.params([{
                        lastPage: true,
                        params: modalParams
                    }], typeInfo.addTitle).then(function (data) {
                    var addData = {};
                    addData.security_events_id = data.event_id;
                    addData.anomaly = data.event_metadata.matching_anomaly;
                    addData.apply_backward = data.apply_backward;
                    addData.conditions = [{
                            'field': type,
                            'value': data.ids
                        }];
                    return addData;
                });
            },
            saveException: function (addData) {
                return anomalyExceptionsDao.add(addData).then(function (response) {
                    return response;
                }, function (error) {
                    return modals.alert('Error adding exception for Anomaly', { title: 'Error' }).then(function () {
                        return $q.reject(error);
                    }, function () {
                        return $q.reject(error);
                    });
                });
            },
            addByEntity: function (type, eventData, eventId) {
                var addParams = {};
                var count = 0;
                _(eventData.metadata.conditions).each(function (data) {
                    if (data.field === type) {
                        addParams.data = data.value;
                        count++;
                    }
                });
                if (count === 0) {
                    addParams.message = 'Unable to find It. You can enter it manually if you know it';
                }
                addParams.event_metadata = eventData;
                addParams.id = eventId;
                return anomalyExceptionsParams.addDialog(type, addParams);
            },
            exceptionLinks: function (entityId, entityType, eventName, args) {
                return _(args.eventData.metadata.conditions).chain().map(function (condition) {
                    return '#' + JSON.stringify({
                        display: 'text',
                        'class': 'display-block link-like',
                        text: condition.label,
                        clickEvent: {
                            name: eventName,
                            entityType: entityType,
                            entityId: entityId,
                            exceptionType: condition.field,
                            args: args
                        }
                    });
                }).compact().value();
            }
        };
        return anomalyExceptionsParams;
    }]);
}());